import React from "react";
import Tooltip from "../tooltip/tooltip";

const InputText = ({ title, value, onChange, autoComplete, placeHolder, disabled, className, tooltip, rows }) => {

    let baseClassName = 'w-full bg-airpark-gray-300 rounded-xl p-2 pl-4 text-airpark-input-field focus:outline-none';

    if (!autoComplete) {
        autoComplete = 'off';
    }

    if (disabled) {
        baseClassName = `${baseClassName} opacity-50`;
    }

    if (!className) {
        className = baseClassName;
    } else {
        className = `${baseClassName} ${className}`;
    }

    return (
        <>
            <div className="flex relative items-center">
                <span className="text-base font-medium pb-1">{title}</span>
                {tooltip &&
                    <Tooltip tooltip={tooltip} />
                }
            </div>
            <textarea value={value ?? ''} rows={rows ?? 3} onChange={(e) => { onChange(e.target.value); }} type="text" disabled={disabled} autoComplete={autoComplete} placeholder={placeHolder} className={className}></textarea>
        </>
    );
}

export default InputText;